// extracted by mini-css-extract-plugin
module.exports = {"modal-window":"style_modal-window__kDG9w","show":"style_show__eLQen","modal-wrapper":"style_modal-wrapper__uOsE4","modal-close":"style_modal-close__lH67n"};